<template>
  <div class="login-wrap">
    <div class="logo">
      <img src="../assets/img/logo2.png" />
    </div>
    <!-- <div class="title loginTitle">智慧畜牧公共服务平台</div> -->
    <el-form
      v-if="type == 1"
      label-position="left"
      :model="subform"
      :rules="rules"
      ref="subform"
      label-width="0px"
      class="demo-ruleForm login-container"
      style="height:300px!important;"
    >
      <div class="text">欢迎登录</div>
      <div>
        <el-form-item prop="username" style="margin: 30px 0!important;">
          <el-input
            type="text"
            v-model="subform.mobile"
            auto-complete="off"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="text" style="margin-bottom: 30px;">
          <div class="inputBox">
            <el-input
              type="text"
              class="yzm"
              v-model="subform.code"
              auto-complete="off"
              placeholder="请输入验证码"
            ></el-input>
          </div>
          <!-- <input type="text"  v-model="subform.code" auto-complete="off" placeholder="请输入验证码" /></div> -->
          <div
            @click="getCode"
            v-if="setCode == '获取验证码'"
            class="code getCode"
          >
            {{ setCode }}
          </div>
          <div v-else class="code colorG">{{ setCode }}</div>
        </el-form-item>
        <div style="margin-bottom:15px;cursor:pointer;" @click="regest(1)">
          去注册
        </div>
      </div>
      <el-form-item style="width:100%;" v-if="type == 1">
        <el-button
          type="primary"
          style="width:100%;"
          @click="submitForm('subform')"
          :loading="logining"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
    <el-form
      v-if="type == 3"
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0px"
      class="demo-ruleForm login-container"
      style="height:480px;"
    >
      <div class="text">请注册</div>

      <div v-if="type == 3">
        <el-form-item prop="username">
          <el-input
            type="text"
            v-model="ruleForm.mobile"
            auto-complete="off"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.userPwd"
            @blur="execl"
            autocomplete="new-password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <div class="passF">
          至少包括大写字母、小写字母、数字、特殊符号中任意三种
        </div>
        <el-form-item prop="password" style="margin-bottom: 30px;">
          <el-input
            type="password"
            v-model="userPassIns"
            @blur="execls"
            autocomplete="new-password"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="text" style="margin-bottom: 30px;">
          <div class="inputBox">
            <el-input
              type="text"
              class="yzm"
              v-model="ruleForm.code"
              auto-complete="off"
              placeholder="请输入验证码"
            ></el-input>
          </div>
          <!-- <input type="text" v-model="ruleForm.code" auto-complete="off" placeholder="请输入验证码"/> -->
          <div
            @click="getCode"
            v-if="setCode == '获取验证码'"
            class="code getCode"
          >
            {{ setCode }}
          </div>
          <div v-else class="code colorG">{{ setCode }}</div>
        </el-form-item>
        <div style="margin-bottom:15px;cursor:pointer;" @click="regest(0)">
          去登录
        </div>
      </div>
      <div style="text-align:center">
        点击注册表示您已阅读并同意微牧云<a
          class="green"
          target="_blank"
          href="http://down.xiaomuding.com/userService.html"
          >《用户协议》</a
        >和<a
          class="green"
          target="_blank"
          href="http://down.xiaomuding.com/conceal.html"
          >《隐私政策》</a
        >
      </div>
      <el-form-item style="width:100%;margin-top:10px;">
        <el-button
          type="primary"
          style="width:100%;"
          @click="regestForm('ruleForm')"
          :loading="logining"
          >注册</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script type="text/ecmascript-6">

  import Vue from 'vue'
  import {

    sendCodeApi,
    registerApi,
    accountSmsLoginApi
  } from '@/api/index'
import {
    getSecret,
    loginCode
  } from '@/api/login'
  export default {
    name: 'login',
    data() {
      return {
        setCode:'获取验证码',
        setCodes:'获取验证码',
        type:1,
        num:60,
        //定义loading默认为false
        logining: false,
        // 记住密码
        pwd:'',
        rememberpwd: false,
        mobile:'',
        code:'',
        subform:{
          mobile:'',
          code:'',
          scope: 'server'
        },
        ruleForm: {
          userPwd:'',
          mobile: '',
          clientFlag:'pc',
          code:''

        },
        //rules前端验证
        rules: {
          mobile: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }],
          userPwd: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }],
        },
        form:{
          mobile:'',
          userPwd:''
        },
        sendCode:{
          codeType: 'login_system_sms_code',
          userAccount: ''
        },
        clock:null,
        userPassIns:'',
        tokenLogin: ''
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      getSecret().then(res => {
        this.tokenLogin = res.data.data;
      })

    },
    // 里面的函数只有调用才会执行
    // sendCode: {
    //     codeType: 'login_system_sms_code',
    //     userAccount: ''
    //   },
    methods: {
      execl(e){

      },
      execls(e){

      },
      regest(type){
          clearInterval(this.clock);
        this.ruleForm.mobile = ''
        this.ruleForm.code = ''
        this.setCodes = '获取验证码'
        this.setCode = '获取验证码'
        this.subform.mobile = ''
        this.subform.code = ''
        this.setCode = '获取验证码';
        this.num = 60; //重置时间
        if(type==0){
          this.type=1
        }else{
           this.type = 3
        }

      },
      regestForm(){
        let reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{1,32}$/;

        console.log(reg.test(this.ruleForm.userPwd), 111)

        if(reg.test(this.ruleForm.userPwd)==true){
            if(this.ruleForm.userPwd==this.userPassIns){
                  registerApi(this.ruleForm).then(res=>{
                      console.log(res.data.code)
                      if (res.data.code > 0) {
                        alert(res.data.msg)
                      } else {
                        this.type = 1
                        this.ruleForm.mobile = ''
                        this.ruleForm.code = ''
                        this.setCodes = '获取验证码'
                      }

                  })
            }else{
              if(this.userPassIns.length>0){
                 alert('两次密码输入不一致，请重新输入密码')
              }

            }
        }else{
          if(this.ruleForm.userPwd.length>0){
            alert('请设置正确的密码')
          }
        }

      },
      getCode(){
        if(this.type==1){
          this.sendCode.userAccount = this.subform.mobile

        }
        if(this.type==3){
          this.sendCode.userAccount = this.subform.mobile
        }
        if(this.sendCode.userAccount==''){
          alert('请输入手机号')
        }else{
          sendCodeApi(this.sendCode).then(res=>{
              if(res.data.code =='0'){
                alert('短信验证码发送成功')
              }else{
                alert(res.data.msg)
              }
              if(res.data.code=='1'){
                return;
              }

                this.setCode =  this.num+'秒后可重新获取';
                let _this = this
                _this.clock = setInterval(function(){
                  _this.num--;
                   if( _this.num > 0){
                  _this.setCode =  _this.num+'秒后可重新获取';
                   }else{
                   clearInterval(_this.clock); //清除js定时器

                   _this.setCode = '获取验证码';
                    _this.num = 60; //重置时间
                   }
                }, 1000);

          })
        }


      },
      //获取info列表
      submitForm(formName) {
        var _this = this
        _this.$refs[formName].validate(valid => {
          if (valid) {

            _this.logining = true
            loginCode(_this.subform, _this.tokenLogin).then(response=>{
                   _this.logining = false
                 localStorage.setItem('token',response.data.data.accessToken)
                 localStorage.setItem('userPhone',_this.subform.mobile)
                localStorage.setItem('userInfo',JSON.stringify(response.data.data))
                 console.log(_this.$store)
                   _this.$router.push({
                     path: '/index'
                   })
            // this.algoList = response.data.data.records
          //   loginCode(_this.subform, _this.loginToken)
          // .then((res) => {
          //   if (res.data.data == null) {
          //     _this.$message({
          //       type: 'none',
          //       message: res.data.msg
          //     });
          //   } else {
          //     localStorage.setItem('token', res.data.data.accessToken);
          //     localStorage.setItem('userPhone', _this.ruleForm.username);
          //     localStorage.setItem('userInfo', JSON.stringify(res.data.data));
          //     _this.subform.mobile = '';
          //     _this.subform.code = '';
          //     _this.setCode = '获取验证码';
          //     _this.loginInfo = res.data.data;
          //     _this.showDialog = false;
          //     _this.getuserO();
          //     _this.getUserInfo();
          //   }

          //   // this.algoList = response.data.data.records
          // })
          // .catch((res) => {
          //   _this.logining = false;
          //   _this.$message({
          //     type: 'error',
          //     message: '账号密码错误，请重新输入'
          //   });
          // });

            }).catch((res) => {
                 _this.logining = false
                 _this.$message({
                   type: 'error',
                   message: '账号密码错误，请重新输入'
                 })

             })





          } else {
            // 获取图形验证码
            // this.getcode()
            this.$message.error('请输入用户名密码！')
            this.logining = false
            return false
          }
        })
      },
    }
  }
</script>
<style scoped>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  height: 100vh;
  margin: 0;
  background: -webkit-linear-gradient(
    0deg,
    rgba(38, 153, 38, 1) 0%,
    rgba(119, 183, 55, 1) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(38, 153, 38, 1) 0%,
    rgba(119, 183, 55, 1) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(38, 153, 38, 1) 0%,
    rgba(119, 183, 55, 1) 100%
  );
  transition: All 0.15s ease-in-out;
  -webkit-transition: All 0.15s ease-in-out;
  -moz-transition: All 0.15s ease-in-out;
  -o-transition: All 0.15s ease-in-out;
  position: relative;
}

.logo {
  position: absolute;
  left: 60px;
  top: 60px;
}

.logo img {
  width: 200px;
}

.title {
  font-weight: 700;
  font-size: 40px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  padding-top: 60px;
}

.login-container {
  position: fixed;
  width: 330px;
  height: 450px;
  background: inherit;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  -moz-box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.247058823529412);
  -webkit-box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.247058823529412);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.247058823529412);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  padding: 30px;
}

.text {
  font-weight: 700;
  font-size: 20px;
  text-align: center;
  line-height: 20px;
  height: 35px;
}

.remember {
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}

/deep/ .el-input__inner {
  line-height: 50px !important;
  height: 50px !important;
  border: none !important;
  background: rgba(245, 247, 250, 1);
}

/deep/ .el-button--primary {
  padding: 0 !important;
  background: -webkit-linear-gradient(
    180deg,
    rgba(48, 191, 48, 1) 0%,
    rgba(149, 229, 69, 1) 100%
  );
  background: -moz-linear-gradient(
    270deg,
    rgba(48, 191, 48, 1) 0%,
    rgba(149, 229, 69, 1) 100%
  );
  background: linear-gradient(
    270deg,
    rgba(48, 191, 48, 1) 0%,
    rgba(149, 229, 69, 1) 100%
  );
  font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 50px;
  display: block;
  text-align: center;
  border: none;
}
/deep/ .el-form-item {
  width: 100%;
}
.h300 {
  height: 450px;
}
.inputBox {
  display: inline-block;
  border-radius: 5px;
  width: 60%;
  background-color: rgba(245, 247, 250, 1);
}
.inputBox .yzm {
  /* border: none;
    border-radius: 5px;
    width: 100%;
    font-size: 16px;
    color: #333;
    height: 44px;
    background: none;
    text-indent: 10px;
    vertical-align: top;
    outline: none; */
}
.getCode {
  display: inline-block;
  height: 46px;
  line-height: 46px;
  border: none;
  outline: none;
  cursor: pointer;
  width: 120px;
  float: right;
  border-radius: 5px;
  /* background: #30bf30;
    color: #fff; */
  text-align: center;
  font-size: 16px;
}
.passF {
  font-size: 12px;
  color: red;
  margin-bottom: 5px;
}
.code {
  position: absolute;
  right: 5px;
  line-height: 50px;
  top: 0;
  cursor: pointer;
}
.colorG {
  color: #999;
}
.green {
  color: #30bf30;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue